<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">归属名</span>
        <el-input v-model="parameter.name" class="item_input" />
      </div>
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button type="primary" icon="el-icon-circle-plus" @click="dialogVisible = true">创建</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="归属id"
        />
        <el-table-column
          prop="book_name"
          label="归属名"
        />
        <!-- <el-table-column prop="roi_standard" label="RIO标准" /> -->
        <el-table-column prop="type_var" label="书籍类型" />
        <el-table-column
          label="操作"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="modify(scope.row)">修改</el-button>
            <!-- <el-button type="primary" size="mini" @click="(drawer = true),(drawerItem = scope.row)">添加</el-button> -->
            <el-button type="warning" size="mini" @click="deleteBooks(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      :title="data.belong_id ? '修改书籍' : '创建书籍'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
      @closed="(data.name = null),(data.belong_id = null),(data.type_var = null)"
    >
      <div class="content">
        <!-- <div class="item">
          <span class="item_title">平台</span>
          <el-select
            v-model="data.platform_id"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in platforms"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div> -->
        <div class="item">
          <span class="item_title">书籍</span>
          <el-input v-model="data.name" class="item_input" />
        </div>
        <div class="item">
          <span class="item_title">书籍类型</span>
          <el-input v-model="data.type_var" class="item_input" />
        </div>
        <!-- <div class="item">
          <span class="item_title">RIO标准</span>
          <el-input v-model="data.roi_standard" class="item_input" type="number" @input="verification" />
          <span style="font-size: 20px;">%</span>
        </div>
        <span style="color: #d01e1e;">注：RIO标准必须是整数，且不能大于100并且不能小于0</span> -->
      </div>
      <div style="display: flex; margin-top: 30px;justify-content: end;">
        <el-button type="primary" @click="determine">确定</el-button>
      </div>
    </el-dialog>

    <el-drawer
      ref="drawer"
      title="详情"
      :visible.sync="drawer"
      :with-header="false"
      size="60%"
    >
      <Details v-if="drawer" :drawer-item="drawerItem" @close="$refs.drawer.closeDrawer()" />
    </el-drawer>
  </div>
</template>

<script>
import { belong_list, del_belong_book, add_belong_book, update_belong_book, channel_platform_list } from '@/api/ListnewLaunchGroup.js'
// import { getPlatform } from '@/api/newLaunchGroup.js'
// import { modifyBookOwnership } from '@/api/newLaunchGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Details from './components/details.vue'
export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        name: null
      },
      data: {
        name: null,
        belong_id: null,
        // roi_standard: null,
        type_var: null,
        // platform_id: null,
        platform_name: null
      },
      dialogVisible: false,
      drawer: false,
      drawerItem: {},
      lastTimeValue: '', // 存储上一次的值
      platforms: []
    }
  },
  created() {
    this.getDataList()
    this.myGetPlatform()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await belong_list(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.data.name = row.book_name
      this.data.belong_id = row.id
      // this.data.platform_id = +row.platform_id || null
      // this.data.roi_standard = row.roi_standard
      this.data.type_var = row.type_var
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    async determine() {
      let text = null
      if (!this.data.name || !this.data.type_var) {
        text = !this.data.name ? '请填写名称' : !this.data.type_var ? '请输入书籍类型' : ''
      }
      if (!text) {
        this.data.belong_id ? await update_belong_book(this.data) : await add_belong_book(this.data)
      }
      this.$message({
        message: text ? !this.data.name ? '请填写名称' : !this.data.type_var ? '请输入书籍类型' : '' : this.data.belong_id ? '修改成功' : '创建成功',
        type: text ? 'warning' : 'success'
      })
      if (!text) {
        this.data.name = null
        this.data.belong_id = null
        // this.data.roi_standard = null
        this.data.type_var = null
        // this.data.platform_id = null
        this.dialogVisible = false
        this.getDataList()
      }
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    // 重置
    reset() {
      this.parameter.name = null
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.getDataList()
    },
    // 删除
    deleteBooks(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await del_belong_book({ id: row.id })
        this.getDataList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },

    verification(value) {
      if (value) {
        const rex = new RegExp(/^100$|^(\d|[1-9]\d)$/)
        this.data.roi_standard = rex.test(value) ? value : this.lastTimeValue
        this.lastTimeValue = rex.test(value) ? value : this.lastTimeValue
      }
    },

    async myGetPlatform() {
      const data = await channel_platform_list()
      this.platforms = data.data.list
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
     margin-bottom: 15px;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}

</style>
